/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

export function mapProspectingAndCityToCityId (item) {
  return item.cityId
}

export function mapProspectingAndCityToCityName (item) {
  return item?.City?.name
}

export function mapProspectingAndEstateTypeToType (item) {
  return item.estateType
}
